<template>
  <node-view-wrapper class="vue-component" :class="offerPhraseEditor ? 'offer-phrase-wrapper' : 'inline-block'">
    <span
      :class="
        offerPhraseEditor
          ? 'offer-phrase-chip'
          : 'flex cursor-pointer items-center space-x-2 rounded-sm bg-yellow-500/20 px-2 py-1 dark:bg-yellow-800/40'
      "
      @click="showPersonalizationDialogue()"
      data-drag-handle>
      <span>{{ previewPhrase }}</span>
      <shellIcons.segments v-if="!offerPhraseEditor" class="w-5 opacity-50" />
    </span>

    <Phrase
      :visible="personalizeDialogVisible"
      @update:visible="personalizeDialogVisible = $event"
      :fallbackText="previewPhrase"
      :phraseId="phraseId"
      @save="save()" />
  </node-view-wrapper>
</template>

<script setup>
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { shellIcons } from '@dashboard/components/icons/shellIcons'
import Phrase from '@dashboard/modules/segment/components/Phrase.vue'
import { usePhraseStore } from '@dashboard/modules/segment/stores/phraseStore'
import { storeToRefs } from 'pinia'
import { computed, inject, ref } from 'vue'
import { phraseTextFor } from '@dashboard/modules/offer/services/offerVariants'

const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  updateAttributes: {
    type: Function,
    required: true
  }
})

const offerPhraseEditor = inject('offerPhraseEditor', null)
const offerPhrasePart = inject('offerPhrasePart', null)
const previewCombination = inject('offerPreviewCombination', null)
const draftPhrases = inject('offerPreviewPhrases', null)
const personalizeDialogVisible = ref(false)

const phraseId = computed(() => props.node.attrs.phraseId)

const phraseStore = usePhraseStore()
const { phrases } = storeToRefs(phraseStore)

const previewPhrase = computed(() => {
  const phrase = (draftPhrases?.value ?? phrases.value).find((p) => p.id === props.node.attrs.phraseId)
  if (phrase) {
    if (previewCombination) {
      return phraseTextFor(phrase, previewCombination.value)
    }
    return phrase.fallbackText
  }
  return undefined
})

const showPersonalizationDialogue = () => {
  if (offerPhraseEditor) {
    offerPhraseEditor({ phraseId: phraseId.value, part: offerPhrasePart?.value })
    return
  }
  personalizeDialogVisible.value = true
}

const save = () => {
  personalizeDialogVisible.value = false
}
</script>

<style scoped>
.offer-phrase-wrapper {
  display: inline;
}
.offer-phrase-chip {
  cursor: pointer;
  color: var(--rm-primary);
  background: var(--rm-primary-soft);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--rm-primary) 28%, transparent);
  border-radius: 5px;
  padding: 1px 6px;
  font-weight: 600;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}
</style>
